import React, { FC } from "react";
import { PillLabel } from "../../../../common";
import { Badge, Popover, Tag } from "antd";
import ReactHtmlParser from "html-react-parser";
import { useTranslation } from "react-i18next";
import Timestamp from "../Timestamp";
import { DocumentSetData } from "../../../../documentSet";
import { useAppSelector } from "../../../../app";
import AddToMemory from "../AddToMemory/AddToMemory";

type Props = {
  activeDocumentSet: DocumentSetData;
};

const DisabledButtonState: FC<Props> = ({ activeDocumentSet }) => {
  const { t } = useTranslation("annotationSideControls");
  const replyText = activeDocumentSet.email?.emailReply?.replyText;
  const labelsEdited = (activeDocumentSet.annotationVersion ?? 0) > 0;
  const editingPausedTagVisible = useAppSelector(
    (state) => state.appReducer.editingPausedTagVisible,
  );
  return (
    <div className="footer-status">
      <div className="buttons__container">
        <PillLabel status={activeDocumentSet.status} />
        <AddToMemory documentSetId={activeDocumentSet.id} />
        {labelsEdited ? (
          <Tag color="blue">
            {t("editAfterExport.labelsEditedTag", {
              defaultValue: "Labels Edited",
            })}
          </Tag>
        ) : null}
        {editingPausedTagVisible ? (
          <Tag color="orange">
            {t("editAfterExport.editingPausedTag", {
              defaultValue: "Editing Paused",
            })}
          </Tag>
        ) : null}
        {replyText ? (
          <Popover
            placement="topRight"
            title={
              <div className="reply-body__header">
                <h4>Reply send to:</h4>
                <h5>
                  {activeDocumentSet.email?.sender?.name}{" "}
                  {`<${activeDocumentSet.email?.sender?.address}>`}
                </h5>
              </div>
            }
            content={ReactHtmlParser(replyText)}
            classNames={{ root: "reply-body" }}
            trigger="click"
          >
            <Badge count={1} overflowCount={9} className="reply-count">
              <div className="footer-reply-button">
                <i className="bi bi-hand-thumbs-down" />
              </div>
            </Badge>
          </Popover>
        ) : null}
      </div>
      <Timestamp />
    </div>
  );
};

export default DisabledButtonState;
